import { onDomReady } from '../../components/dynamic/observer';
class CatalogFilter {
    constructor(selector) {
        this.filterBarContainer = selector;
        this.filterBar = selector.querySelector('[data-drop-filter]');
        this.header = document.querySelector('[data-header]');
        this.headerHeight = undefined;
        this.eventListeners();
    }
    addSticky(){
        this.headerHeight = this.header.offsetHeight;
        this.lastScrollTop = document.documentElement.scrollTop; // Инициализация начальной позиции прокрутки
        const positionRemoveSticky = this.filterBarContainer.getBoundingClientRect().top + document.documentElement.scrollTop //200

        window.addEventListener('scroll', () => {
            const currentScrollTop = document.documentElement.scrollTop; // Текущая позиция прокрутки

            if(this.filterBar.getBoundingClientRect().top <= 0){
                this.filterBar.classList.add("sticky_filter")
            }

            if(window.scrollY >= positionRemoveSticky + this.headerHeight - 50){
                if (currentScrollTop < this.lastScrollTop){
                    this.filterBar.style.top = ` ${this.headerHeight}px`;
                }
                if (currentScrollTop > this.lastScrollTop) {
                    this.filterBar.style.top = 0;
                }
            }

            if(window.scrollY <= positionRemoveSticky + this.headerHeight - 50){
                this.filterBar.classList.remove("sticky_filter")
                this.filterBar.style.top = 0;
            }

            // Обновляем значение последней прокрутки
            this.lastScrollTop = currentScrollTop;
        })
    }

    updateHeaderHeight() {
        this.headerHeight = this.header.offsetHeight;
    }

    //заадём высоту контейнеру
    fixationHeight() {
        const heightContainer = this.filterBarContainer.offsetHeight
        this.filterBarContainer.style.minHeight = `${heightContainer}px`
    }

    eventListeners() {

        this.fixationHeight()

        this.addSticky()

        window.addEventListener('resize', () => {
            this.onResize();
        });

    }

    onResize() {
        this.updateHeaderHeight();
    }
}

onDomReady(() => {
    const catalogSlickSelector = document.querySelector('[data-drop-filter-container]');
        if(catalogSlickSelector){
            new CatalogFilter(catalogSlickSelector);
        }
})